import { render, staticRenderFns } from "./ScrollableVueCardMultipleSlots.vue?vue&type=template&id=4d352e86&scoped=true&"
import script from "./ScrollableVueCardMultipleSlots.vue?vue&type=script&lang=js&"
export * from "./ScrollableVueCardMultipleSlots.vue?vue&type=script&lang=js&"
import style0 from "./ScrollableVueCardMultipleSlots.vue?vue&type=style&index=0&id=4d352e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d352e86",
  null
  
)

export default component.exports